export enum KnowledgeBaseDocumentType {
  PDF = 1,
  Word = 2,
  Excel = 3,
  Image = 4,
  Other = 5
}
